import { Typography } from "@material-ui/core";
import React from "react";
import { useData } from "../../context/DataContext";
import Head from "../Head";
import Collapseable from "../utils/Collapseable";

const Terms = () => {
  const { terms } = useData();
  return (
    <div className="container terms py-5">
      <Head title="Terms & Conditions" />
      <Typography variant="h2">Terms & Conditions</Typography>
      {terms.data?.map((el, i) => (
        <Collapseable i={i} key={i} name="heading" desc="description" {...el} />
      ))}
    </div>
  );
};

export default Terms;
